import React, { useState, useRef } from 'react';

const MessageInput = ({ onSendMessage, disabled }) => {
  const [message, setMessage] = useState('');
  const [attachedPost, setAttachedPost] = useState(null);
  const textareaRef = useRef(null);

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (message.trim() || attachedPost) {
      onSendMessage(message.trim(), attachedPost);
      setMessage('');
      setAttachedPost(null);
      
      // Reset textarea height
      if (textareaRef.current) {
        textareaRef.current.style.height = 'auto';
      }
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSubmit(e);
    }
  };

  const handleTextareaChange = (e) => {
    setMessage(e.target.value);
    
    // Auto-resize textarea
    const textarea = e.target;
    textarea.style.height = 'auto';
    textarea.style.height = Math.min(textarea.scrollHeight, 120) + 'px';
  };

  const removeAttachedPost = () => {
    setAttachedPost(null);
  };

  // This would be used for post sharing functionality
  const handlePostShare = (post) => {
    setAttachedPost(post);
  };

  return (
    <div className="message-input-container">
      {attachedPost && (
        <div className="attached-post-preview">
          <div className="attached-post-header">
            <span>📄 Post anexado:</span>
            <button 
              type="button" 
              className="remove-attachment"
              onClick={removeAttachedPost}
            >
              ×
            </button>
          </div>
          <div className="attached-post-content">
            <strong>{attachedPost.title || 'Post sem título'}</strong>
            {attachedPost.body && (
              <p>{attachedPost.body.substring(0, 100)}...</p>
            )}
          </div>
        </div>
      )}
      
      <form onSubmit={handleSubmit} className="message-input-form">
        <div className="input-row">
          <textarea
            ref={textareaRef}
            value={message}
            onChange={handleTextareaChange}
            onKeyPress={handleKeyPress}
            placeholder="Digite sua mensagem..."
            disabled={disabled}
            className="message-textarea"
            rows={1}
          />
          
          <div className="input-actions">
            {/* Future: Add attachment button, emoji picker, etc. */}
            <button
              type="submit"
              disabled={disabled || (!message.trim() && !attachedPost)}
              className="send-button"
            >
              {disabled ? '...' : '➤'}
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default MessageInput;
